import React from 'react';
import { connect } from 'react-redux';
import { Container, MessageList } from './style';

const Messages = ({ message, type }) =>
  !!message && (
    <Container className={type}>
      {typeof message === 'string' ? (
        message
      ) : (
        <MessageList>{message.map((msg, i) => <li key={i}>{msg}</li>)}</MessageList>
      )}
    </Container>
  );

const mapStateToProps = state => ({
  ...state.messages,
});

export default connect(mapStateToProps)(Messages);



// WEBPACK FOOTER //
// ./src/components/Messages/index.js